import {Box, Button, ButtonGroup, Text as ChakraText, Circle, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, HStack, Icon, IconButton, Stack, VStack, createIcon, useBreakpointValue, useDisclosure, useToken} from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import NotificationMessage from './top-navigation-notification-message';
import React from 'react';
import { formatNotificationDate } from '../../utils/formatNotificationDate';
import { hexToRGBA } from '../../utils/hexToRGBA';

// import { v3ApiService } from '../../services/v3ApiService';


const Close = createIcon({
    displayName: 'Close',
    viewBox: '0 0 24 24',
    d: 'M24 2.49724L14.4972 12L24 21.5028L21.5028 24L12 14.4972L2.49724 24L0 21.5028L9.50276 12L0 2.49724L2.49724 0L12 9.50276L21.5028 0L24 2.49724Z',
  });

   const Splash = createIcon({
    displayName: 'Splash',
    viewBox: '0 0 16 16',
    path: [
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.55686 1.2549C6.55686 0.561839 7.1187 0 7.81177 0H8.15686C8.84993 0 9.41177 0.561839 9.41177 1.2549V14.7451C9.41177 15.4382 8.84993 16 8.15686 16H7.81177C7.1187 16 6.55686 15.4382 6.55686 14.7451V1.2549Z"
          fill="currentColor"
        />
        <path
          d="M14.7451 6.57255C15.4382 6.57255 16 7.13439 16 7.82745V8.17255C16 8.86561 15.4382 9.42745 14.7451 9.42745L1.2549 9.42745C0.561839 9.42745 -3.02948e-08 8.86561 0 8.17255L1.50847e-08 7.82745C4.53794e-08 7.13439 0.561839 6.57255 1.2549 6.57255L14.7451 6.57255Z"
          fill="currentColor"
        />
        <path
          d="M11.7754 2.23637C12.2654 1.7463 13.06 1.7463 13.5501 2.23637L13.7941 2.48039C14.2842 2.97046 14.2842 3.76502 13.7941 4.25509L4.25508 13.7941C3.76501 14.2842 2.97045 14.2842 2.48038 13.7941L2.23636 13.5501C1.74629 13.06 1.74629 12.2654 2.23636 11.7754L11.7754 2.23637Z"
          fill="currentColor"
        />
        <path
          d="M13.7941 11.7754C14.2842 12.2655 14.2842 13.06 13.7941 13.5501L13.5501 13.7941C13.06 14.2842 12.2654 14.2842 11.7754 13.7941L2.23635 4.25509C1.74629 3.76502 1.74629 2.97046 2.23635 2.48039L2.48038 2.23637C2.97045 1.7463 3.76501 1.7463 4.25508 2.23637L13.7941 11.7754Z"
          fill="currentColor"
        />
      </svg>,
    ],
  });
  
   const BlockQuote = createIcon({
    displayName: 'BlockQuote',
    viewBox: '0 0 18 13',
    path: [
      <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.8372 0.0800171C13.4567 0.0800171 14.0236 0.179366 14.5378 0.378064C15.0638 0.576761 15.5138 0.868964 15.8878 1.25467C16.2618 1.62869 16.554 2.08453 16.7644 2.62218C16.9748 3.15983 17.08 3.76761 17.08 4.44552C17.08 5.97666 16.554 7.44352 15.5021 8.84609C14.4619 10.237 12.9424 11.4759 10.9437 12.5629L9.01521 9.81036C9.54118 9.52984 10.0029 9.25517 10.4003 8.98635C10.8093 8.71752 11.16 8.44285 11.4522 8.16234C11.7561 7.88182 12.0132 7.59546 12.2236 7.30326C12.4457 6.99937 12.6444 6.67795 12.8197 6.33899C12.247 6.33899 11.7269 6.25718 11.2593 6.09354C10.8035 5.92991 10.4061 5.70784 10.0671 5.42732C9.73987 5.13512 9.48274 4.80201 9.29573 4.42799C9.12041 4.04228 9.03275 3.6332 9.03275 3.20074C9.03275 2.76828 9.12041 2.36504 9.29573 1.99102C9.48274 1.60531 9.73987 1.2722 10.0671 0.991689C10.4061 0.711174 10.8093 0.4891 11.2769 0.325467C11.7444 0.161834 12.2645 0.0800171 12.8372 0.0800171ZM3.82201 0.0800171C4.44148 0.0800171 5.00835 0.179366 5.52263 0.378064C6.04859 0.576761 6.49858 0.868964 6.8726 1.25467C7.24662 1.62869 7.53882 2.08453 7.74921 2.62218C7.95959 3.15983 8.06479 3.76761 8.06479 4.44552C8.06479 5.97666 7.53882 7.44352 6.48689 8.84609C5.44665 10.237 3.9272 11.4759 1.92854 12.5629L0 9.81036C0.525964 9.52984 0.987644 9.25517 1.38504 8.98635C1.79412 8.71752 2.14477 8.44285 2.43697 8.16234C2.74086 7.88182 2.998 7.59546 3.20838 7.30326C3.43046 6.99937 3.62915 6.67795 3.80448 6.33899C3.23176 6.33899 2.71164 6.25718 2.24411 6.09354C1.78828 5.92991 1.39088 5.70784 1.05193 5.42732C0.724662 5.13512 0.467524 4.80201 0.280514 4.42799C0.105193 4.04228 0.0175321 3.6332 0.0175321 3.20074C0.0175321 2.76828 0.105193 2.36504 0.280514 1.99102C0.467524 1.60531 0.724662 1.2722 1.05193 0.991689C1.39088 0.711174 1.79412 0.4891 2.26165 0.325467C2.72917 0.161834 3.24929 0.0800171 3.82201 0.0800171Z"
          fill="#currentColor"
        />
      </svg>,
    ],
  });
  
   const Dot = createIcon({
    displayName: 'Dot',
    viewBox: '0 0 10 11',
    path: [
      <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5" cy="5.04001" r="5" transform="rotate(180 5 5.04001)" fill="currentColor" />
      </svg>,
    ],
  });

export default function TopNavigationUserNotificationsDrawer(props) {
    const { isOpen, onClose, unreadNotifications, readNotifications, application, authorization, translations } = props;
    const { useState } = React;

    const queryClient = useQueryClient();
    const [isRead, setIsRead] = useState(false);

    const brandButtonColor = application.theme.colors.brand.primary
  
    const isMobile = useBreakpointValue({ base: true, md: false });

    const archiveNotification = async (id) => {
        if (!authorization) {
          throw new Error('Authorization object is null');
        }

        const authToken = authorization.getAuthToken();
        
        const response = await fetch(`${application.API}/v3/notifications/${id}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `AuthToken token=${authToken.authtoken}`,
          },
          body: JSON.stringify({
            viewed: true,
            archived: true,
            viewed_at: new Date(),
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
      };
  
    const archiveNotificationMutation = useMutation({
      mutationFn: (id) => archiveNotification(id),
      onSuccess: () => queryClient.refetchQueries({ queryKey: ['notifications'] }),
    });
  
    const notifications = isRead ? readNotifications : unreadNotifications;
  
    const buttonStyles = {
      border: '1px solid',
      borderRadius: 'full',
      fontSize: '14px',
      fontWeight: 600,
      paddingX: 3,
      paddingY: 2,
    };
  
    const activeButtonStyles = {
      ...buttonStyles,
      backgroundColor: brandButtonColor,
      borderColor: brandButtonColor,
      color: 'white',
      hover: {
        backgroundColor: brandButtonColor,
        color: 'white',
      },
    };
  
    const inactiveButtonStyles = {
      ...buttonStyles,
      backgroundColor: 'white',
      color: '#878787',
      borderColor: '#e0e0e0',
      _hover: {
        backgroundColor: '#ededed',
        color: '#7a7a7a',
      },
    };
  
    const placement = 'right'
  
    return (
      <Drawer
        size={{ base: 'full', md: 'md', lg: 'lg' }}
        placement={placement}
        onClose={onClose}
        isOpen={isOpen}
      >
        <DrawerOverlay backgroundColor="rgba(0, 0, 0, 0.3)" backdropFilter="blur(1px)" />
  
        <DrawerContent marginRight={4} marginTop={14} marginBottom={{base: 0, md: 4}} borderRadius="16px">
          <DrawerHeader
            borderBottomWidth="1px"
            borderBottomColor="#ededed"
            paddingLeft={6}
            paddingRight={4}
            paddingTop={5}
            paddingBottom={4}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <ChakraText fontSize="18px" fontWeight={600} color="baseBlack">
                {translations?.userMenuNotifications || 'Notifications'}
              </ChakraText>
  
              <Close
                boxSize={{base: 4, md: 3}}
                color="#7a7a7a"
                onClick={onClose}
                _hover={{ cursor: 'pointer', color: '#3a3a3a' }}
              />
            </Flex>
          </DrawerHeader>
  
          <DrawerBody paddingX={6} paddingTop={0}>
            <Box paddingY={7} position="sticky" top={0} backgroundColor="white" zIndex={1}>
              <ButtonGroup>
                <Button
                  sx={!isRead ? activeButtonStyles : inactiveButtonStyles}
                  onClick={() => setIsRead(false)}
                >
                  <HStack>
                    <ChakraText margin={0}>{translations?.notificationsUnread || 'Unread'}</ChakraText>
  
                    <Circle
                      paddingY="3px"
                      paddingX="5px"
                      fontSize="10px"
                      backgroundColor={!isRead ? 'whiteAlpha.400' : '#ededed'}
                    >
                      {unreadNotifications?.length}
                    </Circle>
                  </HStack>
                </Button>
  
                <Button
                  sx={isRead ? activeButtonStyles : inactiveButtonStyles}
                  isDisabled={!readNotifications || readNotifications.length === 0}
                  onClick={() => setIsRead(true)}
                >
                  {translations?.notificationsRead || 'Read'}
                </Button>
              </ButtonGroup>
            </Box>
  
            {notifications && notifications.length === 0 && (
              <VStack>
                <Image
                  src="/public/images/no-messages--social-media-no-messages.svg"
                  alt="No Messages"
                />
  
                <ChakraText fontSize="14px" fontWeight={500} color="#adadad">
                  {translations?.notificationsNoUnread || 'You have no unread notifications.'}
                </ChakraText>
              </VStack>
            )}
  
            {notifications && notifications.length > 0 && (
              <Stack>
                {notifications.map((notification) => (
                  <Flex
                    key={notification._id}
                    alignItems="baseline"
                    paddingY={8}
                    borderBottom="1px"
                    borderBottomColor="gray.200"
                    maxWidth="100%"
                    wordBreak="break-word"
                  >
                    <Icon as={Splash} boxSize={3} color={isRead ? '#d4d4d4' : '#EC0040'} />
  
                    <Stack flex={1} spacing={2} marginLeft={2} marginRight={4}>
                      <NotificationMessage message={notification.message} onClose={onClose} />
  
                      <ChakraText fontSize="12px" fontWeight={500} color="#7a7a7a">
                        {formatNotificationDate(notification.createdAt)}
                      </ChakraText>
                    </Stack>
  
                    {!isRead && (
                      <IconButton
                        variant="ghost"
                        size="sm"
                        aria-label="Archive notification"
                        icon={<Close color="#949494" boxSize={2.5} />}
                        _hover={{
                          backgroundColor: '#f6f6f6',
                        }}
                        onClick={() => archiveNotificationMutation.mutate(notification._id)}
                      />
                    )}
                  </Flex>
                ))}
              </Stack>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );

}